export const content = {
  voicePlansCategoryTitle: 'Rolling Monthly',
  voicePlansCategoryDescription: 'Unlimited calls & texts',
  dataOnlyPlansCategoryTitle: 'Data Only plans',
  dataOnlyPlansCategoryDescription: 'Just great value data',
  placeholder: 'Select a plan',
}
